/*
 * @Description: 
 * @Date: 2020-07-16 18:37:11
 * @LastEditTime: 2020-07-23 17:34:06
 */ 
import request from '@/utils/request.js'

export function proCreate(data) {
    return request({
        url: '/api/gen/project/',
        method: 'post',
        data
    })
}

export function proList(params) {
    return request({
        url: 'api/gen/project/',
        method: 'get',
        params
    })
}

export function proDetail(params) {
    return request({
        url: `/api/gen/project/${params.id}`,
        method: 'get'
    })
}

export function proUpdate(data) {
    return request({
        url: `/api/gen/project/${data.id}/`,
        method: 'put',
        data
    })
}

export function proDelete(data) {
    return request({
        url: `/api/gen/project/${data.id}`,
        method: 'delete'
    })
}